var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LineChartGenerator',{attrs:{"data":_vm.internal_value,"options":_vm.options}})
}
var staticRenderFns = []

export { render, staticRenderFns }